module.exports = __webpack_public_path__ + "static/img/chips.a748db5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chips.svg
// module id = roWZ
// module chunks = 0